export {
    // Document Nodes
    InitiateIdentityOtpChallengeDocument,
    VerifyIdentityOtpChallengeDocument,
    IdentitySignUpDocument,
    // Generated Hooks
    useInitiateIdentityOtpChallengeMutation,
    useVerifyIdentityOtpChallengeMutation,
    useIdentitySignUpMutation,
    // Operation Types
    type InitiateIdentityOtpChallengeMutation,
    type InitiateIdentityOtpChallengeMutationVariables,
    type VerifyIdentityOtpChallengeMutation,
    type VerifyIdentityOtpChallengeMutationVariables,
    type IdentitySignUpMutation,
    type IdentitySignUpMutationVariables,
    // Schema Types
    type IdentityOtpChallengeResponse,
    type IdentityAuthResult,
    type IdentitySignUpResult,
} from './identity-mutations';

export { getIdentityClient, resetIdentityClient } from './identity-client';
